export default __webpack_public_path__ + "static/1-a28d59f2393659fe15a83f4fbb1c12e7.webp";